var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 500",
    style: {
      enableBackground: "new 0 0 650 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#14151A;}\n\t.st1{fill:#E3EFFF;}\n\t.st2{fill:#6D89C9;}\n\t.st3{fill:#5872B4;}\n\t.st4{fill:#BED1F9;}\n\t.st5{fill:#A1BAF0;}\n\t.st6{fill:#DDE8FA;}\n\t.st7{fill:#5672B3;}\n\t.st8{fill:#486096;}\n\t.st9{fill:#FFBA53;}\n\t.st10{fill:#FFD353;}\n\t.st11{fill:#B1C9F1;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#E3EDF7;}\n\t.st14{fill:#A7BDE3;}\n\t.st15{fill:#BED1F1;}\n\t.st16{fill:#C9D9F5;}\n\t.st17{fill:#FFE692;}\n\t.st18{fill:#EE9F53;}\n\t.st19{fill:#E38F6F;}\n\t.st20{fill:#5A4868;}\n\t.st21{fill:#58B9D6;}\n\t.st22{fill:#B7E6F1;}\n\t.st23{fill:#4E4C71;}\n\t.st24{fill:#C8776F;}\n\t.st25{fill:#59A5CE;}\n\t.st26{fill:#383752;}\n\t.st27{fill:#18D5E4;}\n\t.st28{fill:#D7EAFF;}\n\t.st29{fill:#CEE1F5;}\n\t.st30{fill:#B9D3F0;}\n\t.st31{fill:#FFF3D3;}\n\t.st32{fill:#FC736B;}\n\t.st33{fill:#D5616B;}\n\t.st34{fill:#75ADD3;}\n\t.st35{fill:#608EAD;}\n\t.st36{fill:#18BFD5;}\n\t.st37{fill:#E9F3FF;}\n\t.st38{fill:#18BCD8;}\n\t.st39{fill:#18B0D8;}\n\t.st40{fill:#556A9C;}\n\t.st41{fill:#3D4C70;}\n\t.st42{font-family:'ArialMT';}\n\t.st43{font-size:18.171px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 650,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.6,363c7,7.6,14.6,14.4,22.6,20.6c2.4,1.8,13.4,0,16.2,0c37.7,0,75.3,0,113,0c54.7,0,109.5,0,164.2,0 c49.3,0,98.6,0,147.9,0c15.6,0,31.2,0,46.7,0c4,0,11.5,1.4,15.2-0.2c7.8-3.4,4.2-19,3.5-26.1c-1.1-11-3.7-22-9.6-31.5 c-16.1-25.9-44.2-35.2-66.4-54.4c-21.6-18.8-36.6-43.8-54.4-66.2c-13.9-17.5-29.6-33.6-46.8-47.9c-11-9.1-22.8-17.6-36.5-21.7 c-11.9-3.6-24.7-3.6-37.1-2.2c-36.3,4.2-71.1,20.6-97.3,46.1c-29.6,28.7-54.2,71.3-93.3,88.1c-21.4,9.2-45.5,10.4-67,19.5 c-21.5,9.1-41,31.1-35,53.6C45.9,349.3,51.6,356.5,57.6,363z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.7,293c4.1,0.7,8.6,0.7,12.3-1.2c1.9-1,3.7-2.6,3.8-4.7c0.1-0.9-0.2-1.9-0.5-2.8c-2.6-7.5-9-13-15.5-17.6 c-4.8-3.5-10-6.9-15.9-7.4c-12.5-1.2-16.1,8.7-9.7,17.6C549.3,285.2,558.5,291.3,568.7,293z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.5,227.4c-36.8-9.4-47.1-28.8-47.1-28.8h-4.2h-34h-13.5c0,0-10.3,19.4-47.1,28.8c0,0-24.4,97,69.6,155.6 h6.8C242.9,324.4,218.5,227.4,218.5,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.9,237.4c-31-7.9-39.7-24.2-39.7-24.2h-3.6h-28.6h-11.3c0,0-8.7,16.4-39.7,24.2 c0,0-20.5,81.6,58.6,130.9h5.7C227.4,319,206.9,237.4,206.9,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.9,241.8c-28.4-7.2-36.4-22.3-36.4-22.3h-3.3h-26.3h-10.4c0,0-8,15-36.4,22.3c0,0-18.9,75,53.8,120.3 h5.2C220.8,316.8,201.9,241.8,201.9,241.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 145.5,
    cy: 283.6,
    rx: 48.9,
    ry: 48.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 145.5,
    cy: 283.5,
    rx: 41.2,
    ry: 41.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "125.5,286.2 143.2,297.1 165.8,258.3 169.9,261.1 146.4,308.7 121.2,294.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "532.2,221.2 540.8,217.7 543,210.5 538.1,202.7 546.6,199.2 548.9,192 544,184.2 552.5,180.8  556.1,169.3 553.4,148.1 540.2,144 526.5,159.9 483.4,296.1 512.9,305.5 537.2,229  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M488.5,279.9l-5.1,16.2l29.6,9.4l5.6-17.8c-8.6-5-18.6-7.8-29.3-7.8C489,279.9,488.8,279.9,488.5,279.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.3,
    y: 228.6,
    transform: "matrix(0.302 -0.9533 0.9533 0.302 140.0486 652.3951)",
    className: "st7",
    width: 144.4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M495.6,300l6-18.8c-1.3-0.3-2.6-0.5-3.9-0.7l-5.8,18.3L495.6,300z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M489.3,286.6c-28.5,0-51.6,23.1-51.6,51.6c0,19.5,10.8,36.5,26.8,45.3h49.7c16-8.8,26.8-25.8,26.8-45.3 C540.9,309.7,517.8,286.6,489.3,286.6z M489.3,365.8c-15.2,0-27.6-12.3-27.6-27.6s12.3-27.6,27.6-27.6s27.6,12.3,27.6,27.6 S504.5,365.8,489.3,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M489.3,381.4c23.9,0,43.2-19.3,43.2-43.2S513.1,295,489.3,295s-43.2,19.3-43.2,43.2 C446.1,362.1,465.4,381.4,489.3,381.4z M489.3,308.1c16.6,0,30.1,13.5,30.1,30.1s-13.5,30.1-30.1,30.1 c-16.6,0-30.1-13.5-30.1-30.1C459.2,321.6,472.6,308.1,489.3,308.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M489.3,377.7c21.8,0,39.5-17.7,39.5-39.5s-17.7-39.5-39.5-39.5s-39.5,17.7-39.5,39.5 S467.4,377.7,489.3,377.7z M489.3,310.6c15.2,0,27.6,12.3,27.6,27.6s-12.3,27.6-27.6,27.6s-27.6-12.3-27.6-27.6 C461.7,323,474,310.6,489.3,310.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M598.4,336.2c0-0.6,0-1.2-0.1-1.8l5.9-2.8l-2.5-7.5l-6.4,1.2c-0.6-1-1.3-2-2.2-3l3.1-5.8l-6.4-4.7l-4.5,4.7 c-1.1-0.5-2.3-0.8-3.5-1.1l-0.9-6.5H573l-0.9,6.5c-1.2,0.3-2.4,0.6-3.5,1.1l-4.5-4.7l-6.4,4.7l3.1,5.8c-0.8,0.9-1.5,1.9-2.2,3 l-6.4-1.2l-2.5,7.5l5.9,2.8c0,0.6-0.1,1.2-0.1,1.8s0,1.2,0.1,1.8l-5.9,2.8l2.5,7.5l6.4-1.2c0.6,1,1.3,2,2.2,3l-3.1,5.8l6.4,4.7 l4.5-4.7c1.1,0.5,2.3,0.8,3.5,1.1l0.9,6.5h7.9l0.9-6.5c1.2-0.3,2.4-0.6,3.5-1.1l4.5,4.7l6.4-4.7l-3.1-5.8c0.8-0.9,1.5-1.9,2.2-3 l6.4,1.2l2.5-7.5l-5.9-2.8C598.4,337.5,598.4,336.9,598.4,336.2z M577,348.2c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12 s12,5.4,12,12C589,342.9,583.6,348.2,577,348.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577,353.8c9.7,0,17.5-7.8,17.5-17.5c0-9.7-7.8-17.5-17.5-17.5c-9.7,0-17.5,7.8-17.5,17.5 C559.5,345.9,567.3,353.8,577,353.8z M577,324.3c6.6,0,12,5.4,12,12c0,6.6-5.4,12-12,12s-12-5.4-12-12 C565,329.6,570.4,324.3,577,324.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 522.1,
    y: 259.7,
    className: "st9",
    width: 45.2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.5,
    y: 242.4,
    className: "st9",
    width: 45.2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.7,
    y: 233.7,
    className: "st10",
    width: 45.2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 251,
    className: "st10",
    width: 45.2,
    height: 8.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.2,161l-38.2-9.4c-2.1-0.5-3.4-2.6-2.9-4.7l5.1-20.9c0.5-2.1,2.6-3.4,4.7-2.9l38.2,9.4 c2.1,0.5,3.4,2.6,2.9,4.7l-5.1,20.9C423.4,160.2,421.3,161.5,419.2,161z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 403.6,
    cy: 142,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M396.4,146.6l2.9-11.6c0.2-1,1.5-1.4,2.2-0.8l10.5,8.6c0.9,0.7,0.6,2.2-0.6,2.4l-13.4,2.9 C397,148.5,396.1,147.6,396.4,146.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M367.2,142.6l-20.2-5c-1-0.3-1.7-1.3-1.4-2.4l2.8-11.3c0.3-1.1,1.3-1.7,2.4-1.4l20.2,5 c1,0.3,1.7,1.3,1.4,2.4l-2.8,11.3C369.4,142.2,368.3,142.9,367.2,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M419,117.9l-16.6-4.1c-1-0.3-1.7-1.3-1.4-2.4l2.2-9c0.3-1.1,1.3-1.7,2.4-1.4l16.6,4.1c1,0.3,1.7,1.3,1.4,2.4 l-2.2,9C421.2,117.5,420.1,118.2,419,117.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M381.8,265.9l-93.5-23c-3.1-0.8-5-3.9-4.3-7l21.1-85.9c0.8-3.1,3.9-5,7-4.3l93.5,23c3.1,0.8,5,3.9,4.3,7 l-21.1,85.9C388,264.8,384.9,266.7,381.8,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M379.9,261.7l-88-21.6c-2.5-0.6-4-3.1-3.4-5.6l19.9-81c0.6-2.5,3.1-4,5.6-3.4l88,21.6c2.5,0.6,4,3.1,3.4,5.6 l-19.9,81C384.9,260.8,382.4,262.3,379.9,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M378.3,259.3l-83.9-20.6c-2.5-0.6-4-3.1-3.4-5.6l19-77.2c0.6-2.5,3.1-4,5.6-3.4l83.9,20.6 c2.5,0.6,4,3.1,3.4,5.6l-19,77.2C383.4,258.4,380.8,259.9,378.3,259.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M391.5,188.7c0,6.3-5.1,11.5-11.5,11.5s-11.5-5.1-11.5-11.5s5.1-11.5,11.5-11.5S391.5,182.4,391.5,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M333,188.1c-9.5-3.7-36.3,20.3-36.3,20.3l0,0l-5.8,23.4c-0.6,2.4,0.9,4.9,3.3,5.4l60.4,14.8l9.5-5.1 l-15.9-24C348.1,223,340.4,191,333,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M369.1,208.7c-8.5,0.4-41.3,25.2-49.6,36.1l59.4,14.6c2.2,0.5,4.5-0.8,5-3l7-28.5 C386,221.2,375.8,208.4,369.1,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M305.5,241.4c0,0,30.5-28.4,39.3-30.5c8.8-2.1,22.4,45.7,22.4,45.7L305.5,241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M317,208.7c-1.8-1.3-12.6,5.9-23.5,13.9L291,233c-0.6,2.5,0.9,5,3.4,5.6l29.9,7.4l0,0 C324.4,246,320.9,211.6,317,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M379.3,231.9c-4.7-0.4-33.3,19.4-33.3,19.4l0,0l32.3,7.9c2.5,0.6,5-0.9,5.6-3.4l3.5-14 C385,236.7,382.6,232.2,379.3,231.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 249.3,
    cy: 191.5,
    r: 59.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M307.8,201l-46.3-9.8l45.9-11.4c-0.4-1.8-0.8-3.6-1.3-5.3l-45.9,11.4l36.2-30.4c-1.1-1.5-2.3-2.9-3.5-4.2 l-36.2,30.4l19.2-43.1c-1.6-0.8-3.3-1.6-5-2.2l-18.8,42.2v-46.2c-0.9,0-1.8-0.1-2.8-0.1s-1.8,0-2.8,0.1v47.2L225.9,137 c-1.7,0.7-3.3,1.5-4.9,2.4l20.7,42.4l-37.2-29.1c-1.2,1.4-2.3,2.8-3.4,4.3l37.2,29.1l-46.3-9.8c-0.5,1.8-0.8,3.6-1.1,5.4 l46.3,9.8L191.1,203c0.4,1.8,0.8,3.6,1.3,5.3l45.9-11.5l-36.3,30.5c1.1,1.5,2.3,2.9,3.5,4.2l36.3-30.5l-19.3,43.3 c1.6,0.8,3.3,1.6,5,2.2l18.9-42.4v46.4c0.9,0,1.8,0.1,2.8,0.1s1.8,0,2.8-0.1v-47.4l20.8,42.6c1.7-0.7,3.3-1.5,4.9-2.4L257,200.9 l37.3,29.2c1.2-1.4,2.3-2.8,3.4-4.3l-37.3-29.2l46.3,9.9C307.2,204.6,307.5,202.8,307.8,201z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 249.3,
    cy: 191.5,
    r: 49.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 249.3,
    cy: 191.5,
    rx: 46.7,
    ry: 46.7
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "427.3,362.2 425.4,376.8 417.6,376.2 418.8,361.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M436.7,178.3c-1.6-2.5-2.1-5.7-1.3-8.6c0.8-2.9,3-5.3,5.7-6.6c1.3-0.6,2.7-0.9,4-0.4 c1.2,0.4,2.1,1.4,3.2,1.9c1.9,0.9,4.2,0.4,6,1.5c1.4,0.9,2,2.5,2.4,4c0.4,1.6,0.5,3.2,1.1,4.7c0.8,1.9,2.4,3.5,4,4.8 c0.7,0.6,1.5,1.2,2,2c0.9,1.3,1.1,3.2,0.4,4.6c-1.2,2.7-1.1,5.8-0.6,8.7c1,5.4,3.1,10.5,5.2,15.5c0.6,1.5,0.8,3,1,4.6 c0.1,0.9,0.1,2-0.6,2.6c-0.6,0.6-1.7,0.6-2.3,1.1c-0.8,0.7-0.8,2-1,3.1c-0.4,1.6-1.6,2.9-3.1,3.5s-3.3,0.2-4.6-0.8 c-1.7-1.3-2.3-3.6-2.9-5.6c-1.5-5.3-3.6-10.5-5.6-15.6c-1.6-4-2.4-8.4-3.6-12.6c-0.7-2.6-1.5-5.2-2.9-7.5 C441.9,181.1,439.3,178.9,436.7,178.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "502.5,299.5 517.2,299.6 517.2,307.4 502.6,307.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M525.9,327.9l-2.1-30.7c0,0-2.7-0.9-5.5,0.4c-2.8,1.2-4.2,1-3.7,2.7s2.3,2,1.6,3.6s-1.3,2.8-0.7,4 c0.6,1.2,3.3,2.6,4.8,7.8c1.7,5.9,2.4,8.5,2.6,9.5C523.6,328,525.9,327.9,525.9,327.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M523.4,326.4c0.9,1.6,2.5,1.5,2.5,1.5l-2.1-30.7c0,0-1-0.3-2.4-0.3L523.4,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M457.1,240c0,0,3.2,7.7,0,27.3c-2.5,15.5,0,32.5,0,32.5s38.4-2.7,50.9-0.8v9.8c0,0-31.7,1.7-42.1,2.2 s-17.2,0.2-19.3-4.5c-2.1-4.6-4.5-26.8-4.5-26.8s-4.1,12.1-5.6,15.8c-1.4,3.7-1.4,3.4-1.6,4.5c-0.2,1.1,1.1,18-3.2,41.3 c-4.3,23.3-4,26.3-4,26.3s-7.2,1.6-10.8-1.6c0,0,3-45.4,4.5-56.9c1.4-11.5,3.5-30.9,5.3-39.4c1.8-8.5,4-28.7,3.9-30.6 C430.5,237.1,457.1,240,457.1,240z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M446.7,188.9c0,0,9.9,6.8,12.2,10.5c2.4,3.7,1.7,8.2,0.3,13.4c-1.4,5.3-1.7,18.8-1.5,23.4 c0.2,4.5,0.2,4.5,0.2,4.5s0.2,0.5-5.5,1.3c-5.7,0.8-10.1-1.6-13.4-1.3c-3.2,0.2-10.2-0.2-10.2-0.2s0.7-10.9,0-11.4 s-14.4,1.1-25.9-1.6l1-6c0,0,10.6,0.8,14.4,0.2c3.7-0.6,11.1-1.2,11.1-1.2s-0.4-3.8-0.6-6.7c-0.2-2.9,0.1-8.4,0.1-8.4 s-9.2,8.2-11.5,9.1c-2.3,0.8-17-0.7-17-0.7l1.5-6c0,0,8.7-0.4,12.4-0.8c0,0,11.1-11.5,14.2-13.2c3.1-1.7,11.5-5.2,11.5-5.2 L446.7,188.9L446.7,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M447,182.8c0,0-0.5,5.6-0.4,6c0.1,0.4,1.4,1,1.4,2c-0.1,1-3.2,8.7-6.4,7.8c-3.2-0.9-4-7.8-3.2-8.7 s1.6-1.6,1.4-5.1C439.7,181.2,447,182.8,447,182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M436.6,176.7c0,0-0.1,8.2,4.6,9.6c4.7,1.4,7.6-7.2,7.9-7.8s0.5,0.3,1.4-1.1c0.9-1.4,0.6-3.9-0.2-3.9 s-1.5-0.1-1.8,1.1c-0.3,1.2-0.4,3.6-1.2,3.2c-0.8-0.4-0.5-3.9-0.8-4.1c-0.8-0.5-1.9,0-2.8-0.4c-0.5-0.2-0.9-0.7-1.4-0.8 c-0.6-0.1-1.3,0.3-1.9,0.5c-1,0.4-2.1,0.2-2.9-0.4c-0.4,0.3-0.5,0.8-0.6,1.3C436.7,174.9,436.7,175.8,436.6,176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M448,226.8c-5,1.8-20.1,2.4-20.1,2.4l0,0c0.6,0,1,0,1.1,0.1c0.4,0.2,0.4,3,0.3,5.8 c5.5-1.6,14.2-3.9,18.7-5.9c6.5-2.9,11.1-18.8,11.1-18.8S453,224.9,448,226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M439.2,217.5c-1.5,0.5-6.5,0.6-10,0.5c0.1,1.5,0.2,2.7,0.2,2.7s7.9-1.1,11.1-1c0,0,6.5-6.2,9.8-14.5 C450.4,205.2,441.5,216.7,439.2,217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M438.6,257.1c0,0,2.2,23.9-2.1,38.4c1.4-3.7,5.6-15.8,5.6-15.8S442.2,266.8,438.6,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M404,221.7c0,0-2.9-1-3.3-1.6c-0.4-0.6-1.1-2.4-1.1-2.4l-0.5,2.2c0,0-2.5-0.5-5.7-1.6s-5.3-2.6-5.9-2.6 c-0.6,0-1.1,0.7-1,1.1c0.1,0.4,0.1,0.4,0.1,0.4s-2.4-1.4-3-1s-0.8,0.8-0.5,1.3s6.9,3.7,7.3,3.8s-6.6-2.4-7.2-2.3 c-0.6,0.2-1,1-0.3,1.4c0.7,0.4,7,2.4,7,2.4s-2.7-0.6-3.2-0.5c-0.5,0.2-0.7,0.6-0.3,1.2s4.3,2.3,5.9,2.5c1.5,0.2,5.6-0.1,6.2,0 s4.6,1.1,4.6,1.1L404,221.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M396.6,383.5h30.8c0,0,1-2.6,0-5.5s-0.7-4.2-2.5-3.9c-1.8,0.3-2.1,2.1-3.7,1.4c-1.5-0.8-2.7-1.5-4-1 c-1.3,0.6-2.8,3.1-8.1,4.3c-6,1.3-8.7,1.8-9.6,1.9C396.6,381.2,396.6,383.5,396.6,383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M398.2,381.1c-1.6,0.8-1.7,2.4-1.7,2.4h30.8c0,0,0.4-1,0.5-2.4H398.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M380.4,116.4l-33.8-8.3c-2.1-0.5-3.4-2.6-2.9-4.7l4.1-16.6c0.5-2.1,2.6-3.4,4.7-2.9l33.8,8.3 c2.1,0.5,3.4,2.6,2.9,4.7l-4.1,16.6C384.6,115.6,382.5,116.9,380.4,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M377,93.5l-13.6-3.6l-1.3-0.3l-0.4,1.5l-3.3,12.6c-0.5-0.6-1.3-1.1-2.3-1.3c-2.1-0.5-4.1,0.3-4.5,1.8 s1,3.2,3,3.8c2.1,0.5,4.1-0.3,4.5-1.8l3.8-14.7l13.6,3.6l-2.4,9.3c-0.5-0.6-1.3-1.1-2.3-1.3c-2.1-0.5-4.1,0.3-4.5,1.8 s1,3.2,3,3.8c2.1,0.5,4.1-0.3,4.5-1.8c0-0.1,0-0.3,0-0.4l0,0l2.9-11l0.4-1.5L377,93.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "494.3,159.9 480.1,150.5 494.3,141.1 508.5,150.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "480.1,165.6 494.3,175 494.3,159.9 480.1,150.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "508.5,165.6 494.3,175 494.3,159.9 508.5,150.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "120.5,161.2 103.2,149.8 120.5,138.3 137.8,149.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "103.2,168 120.5,179.5 120.5,161.2 103.2,149.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "137.8,168 120.5,179.5 120.5,161.2 137.8,149.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M275.1,195.8c-0.6-4.3-3.2-6.9-7.4-8c-0.5-0.1-1,0-1.5-0.5c0.1-0.1,0.2-0.3,0.3-0.3c2.6-1.8,3.7-4.4,3.7-7.6 c0-4.8-2.7-8.5-7.4-9.8c-2.4-0.7-4.8-0.9-7.2-0.9c-0.9,0-1.3-0.2-1.4-1.2c-0.1-2.4-0.4-4.8-0.5-7.1c0-0.3-0.1-0.5-0.1-0.7 l-5.8,0.4c0,0.1,0,0.1,0,0.2c0.3,2.5,0.4,5,0.7,7.5c0.1,0.7-0.1,1-0.8,1.1c-0.9,0.1-1.8,0.2-2.7,0.3c-0.9,0.2-1.2-0.2-1.2-1.1 c-0.1-2.4-0.3-4.8-0.5-7.3c0-0.1,0-0.3-0.1-0.4l-5.6,0.4c0,0.1-0.1,0.3,0,0.6c0.2,2.3,0.3,4.5,0.5,6.8c0.1,1.7,0.1,1.8-1.6,2 c-0.2,0-0.3,0-0.5,0c-2.8,0.2-5.6,0.5-8.4,0.7c-0.1,0-0.1,0-0.1,0l0.6,6.3c1-0.1,2.1-0.2,3.1-0.3c1.9-0.1,3,0.7,3.3,2.7 c0.2,1.3,0.2,2.6,0.4,4c0.6,7.1,1.3,14.3,1.9,21.4c0.1,1.6-0.5,2.3-2.1,2.5c-0.9,0.1-1.7,0.2-2.6,0.2c-0.1,1.4-0.3,4.4-0.5,7.1 c3-0.2,6.1-0.3,9.1-0.7c0.9-0.1,1.1,0.2,1.2,1.1c0.1,2.5,0.4,5.1,0.6,7.6l6-0.3c0,0,0-0.1,0-0.1c-0.2-2.4-0.4-4.8-0.6-7.1 c-0.1-0.9,0.1-1.4,1.1-1.4c0.8,0,1.6-0.1,2.3-0.2c0.9-0.2,1.3,0.1,1.3,1.1c0.1,2.5,0.4,4.9,0.5,7.4c0,0.1,0,0.1,0,0.2l6-0.3 c0,0,0,0,0,0c-0.2-2.4-0.3-4.9-0.5-7.4c-0.1-1.1,0.3-1.5,1.3-1.7c2.5-0.4,4.9-1,7.2-2c3.5-1.4,6.2-3.6,7.4-7.4 C275.4,200.9,275.5,198.4,275.1,195.8z M246.2,188c-0.3-3.4-0.6-6.8-0.9-10.2c-0.1-0.7,0.1-0.9,0.8-1c3.2-0.2,6.3-0.6,9.4,0.3 c3.9,1.2,5.3,5.6,2.6,8.3c-1,1-2.4,1.7-3.4,2c-2.7,0.9-5.2,1.1-7.7,1.2C246.5,188.8,246.3,188.6,246.2,188z M260.8,204.8 c-0.8,0.4-1.6,0.8-2.3,1c-3.4,1.2-6.7,1.3-10,1.7c-0.6,0.1-0.8-0.2-0.8-0.7c-0.4-3.8-0.7-7.6-1.1-11.3c-0.1-0.5,0-0.8,0.6-0.9 c3.4-0.3,6.7-0.8,10.1-0.3c1.1,0.1,2.2,0.4,3.3,0.9c2,0.9,3.1,2.5,3.1,4.7C263.8,202.1,262.7,203.7,260.8,204.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.8,99.2c3.7,11.8-2.9,24.4-14.7,28.2c-11.9,3.7-24.5-2.9-28.2-14.7c-3.7-11.8,2.9-24.5,14.7-28.2 C280.5,80.7,293.1,87.3,296.8,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.3,100.2c3.1,9.9-2.4,20.5-12.3,23.6c-9.9,3.1-20.5-2.4-23.6-12.3c-3.1-9.9,2.4-20.5,12.3-23.6 C279.6,84.8,290.2,90.3,293.3,100.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 275.3,
    cy: 105.9,
    rx: 16.3,
    ry: 16.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M283.6,110.6c0.2-1.8-0.4-3.1-1.9-4c-0.2-0.1-0.4-0.1-0.5-0.3c0,0,0.1-0.1,0.1-0.1c1.2-0.4,1.9-1.3,2.3-2.6 c0.6-1.9-0.1-3.7-1.6-4.7c-0.8-0.5-1.7-0.9-2.6-1.1c-0.3-0.1-0.5-0.2-0.4-0.6c0.2-1,0.4-1.9,0.6-2.9c0-0.1,0-0.2,0-0.3l-2.2-0.5 c0,0,0,0.1,0,0.1c-0.2,1-0.4,2-0.6,3.1c0,0.3-0.2,0.4-0.4,0.3c-0.4-0.1-0.7-0.1-1-0.2c-0.4,0-0.4-0.2-0.3-0.6 c0.2-1,0.4-2,0.6-2.9c0-0.1,0-0.1,0-0.2l-2.1-0.4c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.9-0.4,1.8-0.6,2.8c-0.1,0.7-0.2,0.7-0.8,0.6 c-0.1,0-0.1,0-0.2,0c-1.1-0.2-2.2-0.4-3.3-0.6c0,0,0,0-0.1,0L268,98c0.4,0.1,0.8,0.1,1.2,0.2c0.8,0.2,1.1,0.6,1,1.4 c-0.1,0.6-0.2,1.1-0.3,1.6c-0.6,2.9-1.1,5.8-1.7,8.7c-0.1,0.6-0.5,0.9-1.1,0.8c-0.3-0.1-0.7-0.1-1-0.2c-0.2,0.5-0.6,1.7-1,2.8 c1.2,0.2,2.3,0.5,3.5,0.7c0.3,0.1,0.4,0.2,0.3,0.6c-0.2,1-0.4,2.1-0.7,3.1l2.3,0.5c0,0,0,0,0,0c0.2-1,0.4-1.9,0.6-2.9 c0.1-0.4,0.2-0.6,0.6-0.4c0.3,0.1,0.6,0.1,0.9,0.2c0.4,0,0.5,0.2,0.4,0.6c-0.2,1-0.4,2-0.6,3c0,0,0,0.1,0,0.1l2.3,0.5 c0,0,0,0,0,0c0.2-1,0.5-2,0.7-3c0.1-0.4,0.3-0.6,0.7-0.5c1,0.1,2,0.1,3,0c1.5-0.2,2.8-0.8,3.6-2.1 C283.1,112.6,283.4,111.6,283.6,110.6z M273.6,104.3c0.3-1.4,0.6-2.8,0.8-4.2c0-0.3,0.1-0.4,0.4-0.3c1.2,0.3,2.5,0.4,3.5,1.2 c1.3,0.9,1.4,2.8,0,3.6c-0.5,0.3-1.1,0.4-1.5,0.4c-1.1,0.1-2.1-0.2-3.1-0.3C273.6,104.6,273.5,104.6,273.6,104.3z M277.2,112.6 c-0.4,0.1-0.7,0.2-1,0.2c-1.4,0.1-2.7-0.2-4-0.4c-0.2,0-0.3-0.2-0.2-0.4c0.3-1.5,0.6-3.1,0.9-4.6c0-0.2,0.1-0.3,0.3-0.3 c1.3,0.2,2.6,0.4,3.8,1c0.4,0.2,0.8,0.4,1.1,0.7c0.6,0.6,0.9,1.3,0.6,2.2C278.6,111.8,278,112.3,277.2,112.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "182.1,362.3 181.1,375.9 188.6,376.7 189,374.4 189.9,363.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "230.1,360.6 235.4,374 241.9,370.6 237.2,356.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M166.5,168.6c0,0,1.7-3,0.6-6.3c-1.1-3.4-3.8-3.5-5.4-4.3c-1.6-0.8-6.3-1.6-8.4,0.4s-3,3.5-3.8,4 c-0.8,0.5-1.6,2.7-0.9,4.8c0.7,2.1,2.4,2.6,2.6,4.4s1.5,3.2,3.1,3.8c1.6,0.7,3.8-0.2,3.9-0.5S166.5,168.6,166.5,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M171.6,232.4c0,0,1.1,11,5.8,20.4c4.7,9.3,9.2,22.5,9.5,24.1c0.2,1.7-1.4,19.6-0.6,35 c0.8,15.4-3.6,47.5-5.7,51.9c0,0,5.5,3.2,10.8,1.7c0,0,5-34.1,7.3-46.3c2.3-12.2,3.6-45.3,3.6-45.3s3.4,6.2,4.9,11.4 c1.6,5.1,6.6,30.2,13.6,49.4s8,27.1,8,27.1s8-1.3,10.9-3.7c0,0-10.3-26.1-18.8-63.8c0,0-4.5-24.2-6.7-29.8s-19.6-43.5-21-44.9 C191.7,218.2,171.6,232.4,171.6,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M158.9,181.1c0,0-5.9,5.9-7.4,9.8c-1.5,3.9,3.4,11.4,5,15.4s4.2,9.9,8.6,9.7c0,0,3.6,9,3.4,12.7 c-0.3,3.6-0.3,4.5-0.3,4.5s14.8-2.4,18.8-5.5c4-3.1,8.3-8.3,8.3-8.3s-1.9-0.9-2.4-1.9c-0.6-1-3.2-7.2-3.2-7.2s11.4-3.6,15.1-5.8 c3.8-2.1,4.5-2.6,4.5-2.6l-2.1-4.5c0,0-11.6,4.1-20.1,6.2l-3.6-9.1c0,0,4.2,2.2,5.1,2.4s1.6,0.2,1.6,0.2s-0.5-7.2-0.2-9.2 c0,0-5.7-2.6-9.9-5.7s-4.3-3.2-5.4-3.4c-1-0.2-10,1-10,1L158.9,181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M166,179c0,0-1.3-2.8-1.4-5.2l-6.6,1.7c0,0,1.2,4.1,0.8,5.6c-0.4,1.5,6.3,1.9,7.4,1 C167.4,181.2,166,179,166,179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M166.5,167.7c0,0,0.9,10-3.9,9.8c-4.9-0.2-7.3-6.1-7.3-6.1c-0.7,0.3-1.5-0.1-2.1-0.6s-0.8-1.2-1-1.9 c-0.1-0.4-0.2-1,0.2-1.2c0.2-0.2,0.5-0.2,0.8-0.1c0.3,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.7,0.6,1.1,0.8c0.1,0.1,0.3,0.2,0.5,0.2 c0.2-0.1,0.3-0.3,0.4-0.5c0.2-1.1,0.2-2.2-0.1-3.3c1.9-0.1,3.8-0.1,5.4-1.1c0.4,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.9-0.4 c0.3,0.9,0.6,1.7,1,2.5C165.7,167.4,166.1,167.8,166.5,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M167.4,222.6c7.8-4.4,18.9-10,22.5-11.8c-0.2-0.4-0.3-0.6-0.3-0.6s-15.8,5.3-24.6,5.7 C165.1,215.9,166.5,219.2,167.4,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M169.6,205c-3.4-7.2-7.9-11.8-7.9-11.8c3,4.3,7.2,14,7.2,14c8.9-0.9,18.3-3.7,18.3-3.7L169.6,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M207.5,197.7c0,0,2-0.7,2.7-1.9c0.7-1.2,1.9-1.7,2.1-1.5c0.3,0.2-0.1,1.1,0.2,1s4.8-3.4,5.6-3.7 c0.8-0.3,1.2,0.1,0.9,0.5s-4.2,3.1-4.2,3.1s5.1-2.8,5.7-2.9c0.6-0.1,0.8,0.5,0.8,0.7s-5.9,3.5-5.9,3.5s3.9-1.6,4.3-1.5 c0.4,0.1,0.5,0.4,0.2,0.8c-0.3,0.4-4.2,2.1-4.2,2.1s1.9-0.4,2-0.3s0,0.7-0.5,1s-1.3,0.9-3.4,1.1c-2,0.2-5.1,1.1-5.1,1.1 L207.5,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M204.4,278.4c1.1-5,2.6-15-1.8-20.1c-6.1-6.9-11.4-24.1-11.4-24.1c2.3,13.8,10.9,28.8,11.3,30.8 s-0.3,8.9-0.3,8.9S203.2,275.9,204.4,278.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M180.3,383.5h28.1c0,0,0.7-1.1-2.1-2.4s-7-1.2-14.2-4.3c0,0-1.1-0.3-2.1-1.8c-1-1.4-2.6-0.2-3,0 s-1.8,0.8-3.4-0.1c-1.5-0.9-2.8-0.6-3.4,0.2c-0.6,0.8-0.6,2.6-0.5,3.1C180,378.8,180.4,382.4,180.3,383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M180.3,383.5h28.1c0,0,0.6-1-1.8-2.2h-26.4C180.3,382.1,180.4,383,180.3,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M234.8,379.5l27.3-6.8c0,0,0.4-1.2-2.6-1.8c-3-0.6-7.1,0.5-14.8-0.8c0,0-1.2,0-2.5-1.2 c-1.4-1.1-2.5,0.4-2.9,0.7s-1.6,1.2-3.3,0.7c-1.7-0.5-2.8,0.1-3.2,1s0,2.7,0.3,3.1C233.3,375,234.6,378.4,234.8,379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M234.8,379.5l27.3-6.8c0,0,0.3-1.1-2.3-1.7l-25.6,6.4C234.5,378.2,234.7,379,234.8,379.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 187.2,
    cy: 112.7,
    r: 29.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st36",
    cx: 187.2,
    cy: 112.7,
    r: 24.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st37",
    cx: 187.2,
    cy: 112.7,
    r: 22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "187.2,91.9 187.2,121.9 200.1,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "187.2,108 187.2,121.9 200.1,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "187.2,91.9 187.2,121.9 174.2,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "187.2,108 187.2,121.9 174.2,113  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "187.2,133.4 200.6,115.1 187.2,124.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "187.2,133.4 173.8,115.1 187.2,124.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M353.7,347.9h-61.4c-1.6,0-2.9-1.3-2.9-2.9v-61.4c0-1.6,1.3-2.9,2.9-2.9h61.4c1.6,0,2.9,1.3,2.9,2.9V345 C356.6,346.6,355.3,347.9,353.7,347.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.9,
    y: 287.1,
    className: "st18",
    width: 54.3,
    height: 54.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.5,
    y: 290.8,
    className: "st9",
    width: 47,
    height: 47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M300.1,267.7L300.1,267.7c-1,0-1.9,0.8-1.9,1.9v11.2h3.8v-11.2C302,268.5,301.1,267.7,300.1,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M311.6,267.7L311.6,267.7c-1,0-1.9,0.8-1.9,1.9v11.2h3.8v-11.2C313.4,268.5,312.6,267.7,311.6,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M323,267.7L323,267.7c-1,0-1.9,0.8-1.9,1.9v11.2h3.8v-11.2C324.9,268.5,324.1,267.7,323,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M334.5,267.7L334.5,267.7c-1,0-1.9,0.8-1.9,1.9v11.2h3.8v-11.2C336.4,268.5,335.5,267.7,334.5,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M346,267.7L346,267.7c-1,0-1.9,0.8-1.9,1.9v11.2h3.8v-11.2C347.9,268.5,347,267.7,346,267.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M346,360.9L346,360.9c1,0,1.9-0.8,1.9-1.9v-11.2h-3.8v11.2C344.1,360.1,345,360.9,346,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M334.5,360.9L334.5,360.9c1,0,1.9-0.8,1.9-1.9v-11.2h-3.8v11.2C332.6,360.1,333.5,360.9,334.5,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M323,360.9L323,360.9c1,0,1.9-0.8,1.9-1.9v-11.2h-3.8v11.2C321.2,360.1,322,360.9,323,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M311.6,360.9L311.6,360.9c1,0,1.9-0.8,1.9-1.9v-11.2h-3.8v11.2C309.7,360.1,310.5,360.9,311.6,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M300.1,360.9L300.1,360.9c1,0,1.9-0.8,1.9-1.9v-11.2h-3.8v11.2C298.2,360.1,299,360.9,300.1,360.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M369.7,291.3L369.7,291.3c0-1-0.8-1.9-1.9-1.9h-11.2v3.8h11.2C368.8,293.2,369.7,292.4,369.7,291.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M369.7,302.8L369.7,302.8c0-1-0.8-1.9-1.9-1.9h-11.2v3.8h11.2C368.8,304.7,369.7,303.9,369.7,302.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M369.7,314.3L369.7,314.3c0-1-0.8-1.9-1.9-1.9h-11.2v3.8h11.2C368.8,316.2,369.7,315.3,369.7,314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M369.7,325.8L369.7,325.8c0-1-0.8-1.9-1.9-1.9h-11.2v3.8h11.2C368.8,327.6,369.7,326.8,369.7,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M369.7,337.2L369.7,337.2c0-1-0.8-1.9-1.9-1.9h-11.2v3.8h11.2C368.8,339.1,369.7,338.3,369.7,337.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.4,337.2L276.4,337.2c0,1,0.8,1.9,1.9,1.9h11.2v-3.8h-11.2C277.2,335.4,276.4,336.2,276.4,337.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.4,325.8L276.4,325.8c0,1,0.8,1.9,1.9,1.9h11.2v-3.8h-11.2C277.2,323.9,276.4,324.7,276.4,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.4,314.3L276.4,314.3c0,1,0.8,1.9,1.9,1.9h11.2v-3.8h-11.2C277.2,312.4,276.4,313.3,276.4,314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.4,302.8L276.4,302.8c0,1,0.8,1.9,1.9,1.9h11.2v-3.8h-11.2C277.2,300.9,276.4,301.8,276.4,302.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M276.4,291.3L276.4,291.3c0,1,0.8,1.9,1.9,1.9h11.2v-3.8h-11.2C277.2,289.5,276.4,290.3,276.4,291.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332.6,
    y: 278,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.2,
    y: 278,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.2,
    y: 278,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.7,
    y: 278,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 289.5,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 335.4,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 300.9,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 312.4,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 323.9,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.2,
    y: 347.9,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 312.4,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 300.9,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 289.5,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 323.9,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.7,
    y: 335.4,
    className: "st41",
    width: 2.7,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.1,
    y: 278,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.2,
    y: 347.9,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.6,
    y: 347.9,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.7,
    y: 347.9,
    className: "st41",
    width: 3.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.1,
    y: 347.9,
    className: "st41",
    width: 3.8,
    height: 2.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M406.9,283.4h-15.6c-0.1,0-0.2,0.1-0.3,0.1l-8.3,11.3h-10.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h11 h11.7c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-11l7.9-10.7h15.4c0.2,0,0.4-0.2,0.4-0.4S407.1,283.4,406.9,283.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400.6,307.5c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-28.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4H400.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.3,326.2h-13.9l-4.4-7.4c-0.1-0.1-0.2-0.2-0.3-0.2h-14.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h14.1 l4.4,7.4c0.1,0.1,0.2,0.2,0.3,0.2h14.1c0.2,0,0.4-0.2,0.4-0.4S403.5,326.2,403.3,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.2,336H375c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h21.2c0.2,0,0.4-0.2,0.4-0.4S396.4,336,396.2,336z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.1,296.4c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2h-14.7l-3.8-6.7c0-0.1-0.1-0.1-0.2-0.1h-6.7 c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h6.6l3.6,6.4h-16.8l-3.9-3c-0.1-0.1-0.2,0-0.3,0c-0.1,0.1-0.1,0.2,0,0.3l3.9,3 c0,0,0.1,0,0.1,0L273.1,296.4L273.1,296.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.1,309.6h-23.8c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h23.8c0.1,0,0.2-0.1,0.2-0.2 C273.2,309.6,273.2,309.6,273.1,309.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.1,324.1h-17.8c-0.1,0-0.2,0.1-0.2,0.2v7.1h-10.2c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h10.4 c0.1,0,0.2-0.1,0.2-0.2v-7.1h17.6c0.1,0,0.2-0.1,0.2-0.2S273.2,324.1,273.1,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.4,341.2h-17.9c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h17.9c0.1,0,0.2-0.1,0.2-0.2 C271.6,341.3,271.5,341.2,271.4,341.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M410.6,283.7c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C409.8,281.9,410.6,282.7,410.6,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M398.2,295.2c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C397.4,293.4,398.2,294.2,398.2,295.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M404.2,307.1c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C403.4,305.3,404.2,306.1,404.2,307.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 398,
    cy: 336.3,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M407,326.6c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C406.1,324.8,407,325.6,407,326.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M237.6,292c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8C236.8,290.1,237.6,290.9,237.6,292z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M247.7,289.5c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C246.9,287.6,247.7,288.5,247.7,289.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M244.8,331.5c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8 C244,329.7,244.8,330.5,244.8,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M253.5,341.4c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8S253.5,340.4,253.5,341.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 247.7,
    cy: 309.8,
    r: 1.8
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 302.7303 321.0676)",
    className: "st12 st42 st43"
  }, "NFT")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.526d9898.svg";
export { ForwardRef as ReactComponent };